import React from 'react'

const GRNHistory = (props) =>  {
    const { sellerGRNQCPunch, materialDetails } = props
    
    const docNoObject = {}
    sellerGRNQCPunch?.map(eachGRNPunch => {
        if (Object.keys(docNoObject).includes(eachGRNPunch?.docNo)){
            docNoObject[eachGRNPunch?.docNo].push(eachGRNPunch) 
        } else {
            docNoObject[eachGRNPunch?.docNo] = [eachGRNPunch]
        }
    })

    const relatedGRNs = Object.values(docNoObject)

    return (
        <>  
            {   
                relatedGRNs.length > 0 ?
                    <div className="custom-table-container">
                        <table className="custom-product-table ml-2 mb-0 mt-2">
                            <thead>
                                <tr className="">
                                    <th className="">DATE</th>
                                    <th className="">PRODUCT</th>
                                    <th className="">SPECIFICATION</th>
                                    <th className="">RECEIVED QUANTITY</th>
                                    <th className="">ACCEPTED QUANTITY</th>
                                    <th className="">REJECTED QUANTITY</th>
                                    <th className="">SHORT QUANTITY</th>
                                </tr>   
                            </thead>
                            <tbody style={{ fontSize: "10px" }}>
                                {
                                    relatedGRNs?.map((eachGRNItems, eachGRNItemIndex) => {
                                    const customRowClassName = eachGRNItemIndex % 2 === 0 ? "" : "custom-row-background"
                                    return (
                                            eachGRNItems?.map((eachGRN, index) => {
                                            const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial.materialId === eachGRN?.materialId)
                                            return(
                                                    <tr className={`${customRowClassName}`} >
                                                        { index === 0 && <td className="" rowSpan={eachGRNItems.length} style={{ textAlign: "center" }}>{(new Date(eachGRNItems[0]?.processedDate)).toLocaleDateString()}</td> }
                                                        <td className="" style={{ textAlign: "center", padding:"4px", fontSize:"12px" }}>{relatedMaterial?.productName}</td>
                                                        <td className="" style={{ textAlign: "center", padding:"4px", fontSize:"12px" }}>{relatedMaterial?.productSpecification}</td>
                                                        <td className="" style={{ textAlign: "center", padding:"4px", fontSize:"12px" }}>{eachGRN?.receivedQuantity}</td>
                                                        <td className="" style={{ textAlign: "center", padding:"4px", fontSize:"12px" }}>{eachGRN?.acceptedQuantity}</td>
                                                        <td className="" style={{ textAlign: "center", padding:"4px", fontSize:"12px" }}>{eachGRN?.rejectedQuantity}</td>
                                                        <td className="" style={{ textAlign: "center", padding:"4px", fontSize:"12px" }}>{eachGRN?.shortQuantity}</td> 
                                                    </tr>
                                            )   
                                    }))
                                    })
                                }
                            </tbody>
                        </table> 
                    </div>
                    : 
                    ""
            }
        </>
  )
}

export default GRNHistory;